import { useTranslation } from "react-i18next";
import { Checkbox, Label } from "ui";

export interface Props {
  id: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Confirm(props: Props) {
  const { t } = useTranslation();
  return (
    <>
      {props.description && <div>{props.description}</div>}
      <div className="pt-4">
        <Label htmlFor={props.id} className="flex items-center space-x-2">
          <Checkbox
            id={props.id}
            disabled={props.disabled}
            checked={props.checked}
            onCheckedChange={props.onChange}
          />
          <div>{t("formPage.confirm")}</div>
        </Label>
      </div>
    </>
  );
}
